export default __webpack_public_path__ + "static/media/a037-4.102d3d6d.svg";